import React from 'react';
import { Modal } from 'react-bootstrap';

const backdropStyle = {
  position: 'fixed',
  zIndex: 1040,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: '#000',
  opacity: 0.5,
};

const UpgradeSuccess = ({ show, planText, hidePlanModal, exitedPlanModal }) => (
  <Modal
    dialogClassName="user-plan-modal upgrade-alert-modal"
    show={show}
    onHide={hidePlanModal}
    onExited={exitedPlanModal}
    renderBackdrop={() => <div style={backdropStyle} />}
  >
    <Modal.Header closeButton />
    <Modal.Body>
      <div className="content">
        <div className="heading">Upgrade successful.</div>
        <p>
          Your account has now been successfully upgraded to the Cosynd{' '}
          <b>{planText}.</b>
        </p>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <div className="buttons">
        <button onClick={hidePlanModal}>Continue</button>
      </div>
    </Modal.Footer>
  </Modal>
);

export default UpgradeSuccess;



// WEBPACK FOOTER //
// src/components/UserPlan/UpgradeSuccess.jsx